import React from 'react';
 
const Conclusion=()=>
{
  return (
  <div>Welcome to Dashboard1</div>
  );
}
 
export default Conclusion;